import SecurityService from './securityService.js';

const CHECK_USER_AUTHENTICATED = 'CHECK_USER_AUTHENTICATED';
const SILENT_SIGN_IN = 'SILENT_SIGN_IN';
const ACCEPT_TC = 'ACCEPT_TC';

const initialState = {
  isAuthenticated: false,
  permissions: [],
  userId: -1,
  userName: null,
  parentUserId: null,
  parentUserName: null,
  fullName: null,
  email: null,
  hasAcceptedTC: true,
  accessToken: null,
  idToken: null,
};

const mapLoggedInUser = (user) => {
  return {
    isAuthenticated: true,
    userId: user.profile.web_user_id,
    fullName: user.profile.web_user_fullname,
    email: user.profile.web_user_email,
    hasAcceptedTC:
      user.profile.web_user_accepted_terms &&
      user.profile.web_user_accepted_terms.toLowerCase() === 'true',
    accessToken: user.access_token,
    idToken: user.id_token,
  };
};

export const actionCreators = {
  checkLogin: () => async (dispatch, getState) => {
    const user = await SecurityService.loginAsync();
    if (!user || user.expired) {
      dispatch({ type: CHECK_USER_AUTHENTICATED, initialState });
    } else {
      const data = mapLoggedInUser(user);
      dispatch({ type: CHECK_USER_AUTHENTICATED, data });
    }
  },
  silentSignin: (callback) => async (dispatch, getState) => {
    const user = await SecurityService.signinSilent();
    if (user) {
      const data = mapLoggedInUser(user);
      dispatch({ type: SILENT_SIGN_IN, data });
      callback();
    }
  },
  acceptTc: () => {
    return { type: ACCEPT_TC };
  },
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === CHECK_USER_AUTHENTICATED) {
    return { ...state, ...action.data };
  } else if (action.type === SILENT_SIGN_IN) {
    return { ...state, ...action.data };
  } else if (action.type === ACCEPT_TC) {
    state.hasAcceptedTC = true;
    return { ...state };
  }

  return state;
};
